import { Flex, Image, Text } from '@chakra-ui/react'
import React, { useState } from 'react'
import { useContext } from 'react'
import { ThemeContext } from '../context/ThemeContext'
import { memo } from 'react'

const SingleSkills = ({ image, skill, i }) => {
    const { Theme } = useContext(ThemeContext)
    const [hover, setHover] = useState(false)
    function MouseOver() {
        setHover(true)
    }
    function MouseOut() {
        setHover(false)
    }

    return (
        <Flex data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000" mb={[2, 2, 0, 0, 0]} borderRadius={"5"} pt={"2"} onMouseOut={MouseOut} className="soft2" border={Theme === "dark" && "2px solid  #F2AA4CFF"} flexDir={"column"} alignItems={"center"} justifyContent={"center"} >
            <Flex onMouseOver={MouseOver} flexDir={"column"} alignItems={"center"} justifyContent={"center"}  >
                <Image width={"75%"} src={image} alt={skill} />
                <Text fontWeight={"500"} mt="3" color={Theme === 'dark' ? "#fff" : "blackAlpha.700"} fontSize={[10, 10, 13, 15, 17]} >{skill}</Text>
            </Flex>
        </Flex >
    )
}
const customComparator = (prevProps, nextProps) => {
    return nextProps.post === prevProps.post;
  };
export default memo(SingleSkills,customComparator)